import { render } from "./UserGroupContent.vue?vue&type=template&id=04239d44"
import script from "./UserGroupContent.vue?vue&type=script&lang=js"
export * from "./UserGroupContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__